/**
 * Detect if advisor response qualifies as an artifact-grade output
 * P1 Milestone B: Artifact rendering logic
 */

export interface ArtifactMetadata {
  isArtifact: boolean
  title?: string
  sectionCount?: number
  hasTable?: boolean
}

export function detectArtifact(content: string): ArtifactMetadata {
  if (!content || content.trim().length === 0) {
    return { isArtifact: false }
  }

  const lines = content.trim().split("\n")

  // Extract title (first H1 or H2 heading)
  let title: string | undefined
  const titleMatch = content.match(/^#\s+(.+)$/m) || content.match(/^##\s+(.+)$/m)
  if (titleMatch) {
    title = titleMatch[1].trim()
  }

  // Count sections (H2 headings after the title)
  const h2Headings = content.match(/^##\s+(.+)$/gm)
  const sectionCount = h2Headings ? h2Headings.length : 0

  // Check for tables
  const hasTable = /\|.*\|/.test(content) && /\|-+\|/.test(content)

  // Detect if primarily a question
  const isPrimaryQuestion = content.trim().endsWith("?") && content.split("\n").length < 3

  // Artifact criteria: ALL must be true
  // 1. Has title
  // 2. Has ≥2 sections OR has a table
  // 3. Not primarily a question
  const isArtifact = Boolean(title && (sectionCount >= 2 || hasTable) && !isPrimaryQuestion)

  return {
    isArtifact,
    title,
    sectionCount,
    hasTable,
  }
}
